import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";

// Zdieľaný layout pre podstránky (Header + obsah + Footer).
const Layout = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="App bg-campaign-cream min-h-screen">
      <Header />
      <main className="pt-16 sm:pt-20">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
